module.exports = __webpack_public_path__ + "img/Commerce_Integration_2.bf978c0b.png";